import React from "react";
import { htmlSafe } from "modules/utils";
import { TableSectionProps } from ".";

const TableSectionSkeleton: React.FC<TableSectionProps> = ({ noContainer, table }) => {
  return noContainer ? (
    <div style={{ visibility: "hidden" }}>{htmlSafe(table)}</div>
  ) : (
    <div style={{ visibility: "hidden" }}>
      <div>
        <div>{htmlSafe(table)}</div>
      </div>
    </div>
  );
};

export default TableSectionSkeleton;
